module.exports = __webpack_public_path__ + "media/images/default-article-2fd9266a.png";